import { useState } from 'react'
import styled from 'styled-components'
import { Box, Flex, Heading, Skeleton, Text, Button } from '@pancakeswap/uikit'
import { LotteryStatus } from 'config/constants/types'
import PageSection from 'components/PageSection'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { useFetchLottery, useLottery } from 'state/lottery/hooks'
import {
  TITLE_BG,
  GET_TICKETS_BG,
  FINISHED_ROUNDS_BG,
  FINISHED_ROUNDS_BG_DARK,
  CHECK_PRIZES_BG,
} from './pageSectionStyles'
import useGetNextLotteryEvent from './hooks/useGetNextLotteryEvent'
import useStatusTransitions from './hooks/useStatusTransitions'
import Hero from './components/Hero'
import NextDrawCard from './components/NextDrawCard'
import Countdown from './components/Countdown'
import HistoryTabMenu from './components/HistoryTabMenu'
import YourHistoryCard from './components/YourHistoryCard'
import AllHistoryCard from './components/AllHistoryCard'
import CheckPrizesSection from './components/CheckPrizesSection'
import HowToPlay from './components/HowToPlay'
import useShowMoreUserHistory from './hooks/useShowMoreUserRounds'
import { PageMeta } from '../../components/Layout/Page'
import Page from '../Page'
import Jackpot from './components/Jackpot'
import WinningNumbers from './components/WinningNumbers'
import LastWinningNumbers from './components/LassWinningNumbers'
import PrizeAllocation from './components/PrizeAllocation'
import Dividens from './components/Dividens'
import Timer from './components/Timer'
import Tickets from './components/Tickets'
import YourTickets from './components/YourTickets'
import { ethers } from 'ethers'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledJackpot = styled(Text)`
  background: ${({ theme }) =>
    theme.isDark ? 'linear-gradient(90deg, #FFE259 0%, #FFA751 100%)' : theme.colors.hardTextColor};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-size: 36px;
  font-weight: 800;
`

const StyledDigit = styled(Text)`
  width: 40px;
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: #141e31;
  border-radius: 6px;
  padding: 12px 14px;
`

const StyledLotteryDigit = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: url('/lotterydigitbg.png') no-repeat center center / cover;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 120px;
`

const StyledRoundedDigit = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: ${({ theme }) => (theme.isDark ? '#141E31' : '#8791A5')};
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 120px;
`

const StyledSeparator = styled(Text)`
  self-align: center;
  self-justify: center;
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 8px;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledHardText = styled(Text)`
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const StyledHr = styled.hr`
  border-color: ${({ theme }) => theme.colors.hrColor};
  border-size: 1px;
  border-style: solid;
  width: 90%;
  margin-top: 20px;
`

const StyledJackpotHero = styled(Flex)`
  @media screen and (max-width: 967px) {
    flex-direction: column;
  }
`

const StyledStyledCard = styled(StyledCard)`
  justifycontent: space-evenly;
  alignitems: flex-start;
  @media screen and (max-width: 967px) {
    flex-direction: column;
  }
`
const StyledActionButtons = styled(Flex)`
  @media screen and (max-width: 440px) {
    flex-direction: column;
  }
`

const genericprovider = new ethers.providers.JsonRpcProvider('https://nd-699-384-776.p2pify.com/a0bb181b833e6a91efba0ec513109c50')

const Lottery = () => {
  useFetchLottery()
  useStatusTransitions()
  const { t } = useTranslation()
  const { isDark, theme } = useTheme()
  const {
    currentRound: { status, endTime },
  } = useLottery()
  const [historyTabMenuIndex, setHistoryTabMenuIndex] = useState(0)
  const endTimeAsInt = parseInt(endTime, 10)
  const { nextEventTime, postCountdownText, preCountdownText } = useGetNextLotteryEvent(endTimeAsInt, status)
  const { numUserRoundsRequested, handleShowMoreUserRounds } = useShowMoreUserHistory()

  return (
    <>
      <PageMeta />
      <Page style={{ paddingBottom: 120 }}>
        <div style={{ maxWidth: 1280 }}>
          <StyledJackpotHero style={{ gap: 40, width: '100%' }}>
            <Jackpot genericprovider={genericprovider} />
            <Timer genericprovider={genericprovider} />
          </StyledJackpotHero>

          <LastWinningNumbers genericprovider={genericprovider} />

          <StyledJackpotHero style={{ marginTop: 40, gap: 40, width: '100%' }}>
            <Tickets genericprovider={genericprovider} />
            <Dividens genericprovider={genericprovider} />
          </StyledJackpotHero>

          <StyledJackpotHero style={{ marginTop: 40, gap: 40, width: '100%' }}>
            <YourTickets genericprovider={genericprovider} />
            <WinningNumbers genericprovider={genericprovider} />
          </StyledJackpotHero>

          <StyledStyledCard
            style={{
              paddingLeft: 16,
              paddingRight: 16,
              marginTop: 40,
              gap: 80,
              boxShadow: theme.isDark ? '' : '8px 24px 24px rgba(15, 20, 30, 0.12)',
            }}
          >
            <Flex
              style={{
                flexGrow: 1,
                flexDirection: 'column',
                textAlign: 'center',
                marginTop: 40,
                marginBottom: 40,
                alignContent: 'flex-start',
              }}
            >
              <img src="/purchasing.png" alt="" style={{ width: 100, margin: '0 auto' }} />
              <StyledHardText bold style={{ margin: '0 auto', paddingTop: 10 }}>
                Buy Tickets
              </StyledHardText>
              <Text style={{ margin: '0 auto', paddingTop: 10, width: 200 }}>
                Buy your ticket for just $2.00 USDT and choose your ticket numbers.
              </Text>
            </Flex>
            <Flex
              style={{
                flexGrow: 1,
                position: 'relative',
                flexDirection: 'column',
                textAlign: 'center',
                marginTop: 40,
                marginBottom: 40,
                alignContent: 'flex-start',
              }}
            >
              <img src="/wait.png" alt="" style={{ width: 100, margin: '0 auto' }} />
              <StyledHardText bold style={{ margin: '0 auto', paddingTop: 10 }}>
                Wait for the Draw
              </StyledHardText>
              <Text style={{ margin: '0 auto', paddingTop: 10, width: 200 }}>
                Wait for the daily draw at 12:00 UTC+0
              </Text>
            </Flex>
            <Flex
              style={{
                flexGrow: 1,
                position: 'relative',
                flexDirection: 'column',
                textAlign: 'center',
                marginTop: 40,
                marginBottom: 40,
                alignContent: 'flex-start',
              }}
            >
              <img src="/win.png" alt="" style={{ width: 100, margin: '0 auto' }} />
              <StyledHardText bold style={{ margin: '0 auto', paddingTop: 10 }}>
                Check for Prizes
              </StyledHardText>
              <Text style={{ margin: '0 auto', paddingTop: 10, width: 200 }}>
                Once the round’s over, check to see if you’ve won!
              </Text>
            </Flex>
          </StyledStyledCard>

          <StyledJackpotHero style={{ marginTop: 40, gap: 40, width: '100%', position: 'relative' }}>
            <PrizeAllocation genericprovider={genericprovider} />
            <StyledCard style={{ flexDirection: 'column', justifyContent: 'flex-start' }}>
              <StyledSoftText style={{ marginTop: 20 }}>Players Insights</StyledSoftText>
              <StyledHr />
              <Flex style={{ paddingLeft: '5%', paddingRight: '5%', marginTop: 20 }}>
                <div style={{ width: '40%' }}>
                  <StyledSoftText style={{ marginBottom: 12, fontSize: 12 }}>
                    Did you know your odds of winning a prize are the same in every Lottery drawing?
                  </StyledSoftText>
                  <StyledSoftText style={{ marginBottom: 12, fontSize: 12 }}>
                    You have a 1 in 22 chance of winning a prize when the advertised jackpot is $100.000.
                  </StyledSoftText>
                  <StyledSoftText style={{ marginBottom: 12, fontSize: 12 }}>
                    You still have a 1 in 22 chance of winning a prize when the advertised jackpot is $100 million.
                  </StyledSoftText>
                  <StyledSoftText style={{ marginBottom: 12, fontSize: 12 }}>
                    Even if there are more tickets sold in a particular drawing, your odds of winning a prize are the
                    same.
                  </StyledSoftText>
                </div>
                <div style={{ width: '60%', textAlign: 'right', paddingBottom: 220 }}>
                  <Text>ODDS OF WINNING</Text>
                  <StyledJackpot>1 in 22</StyledJackpot>
                </div>
              </Flex>
            </StyledCard>
          </StyledJackpotHero>
        </div>
      </Page>
    </>
  )
}

export default Lottery
